import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapabilityDetailsComponent } from './capability-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';


@NgModule({
  declarations: [
    CapabilityDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
  ],
  exports: [
    CapabilityDetailsComponent
  ],
})
export class CapabilityDetailsModule { }
